import { Link } from 'react-router';
import { useTranslation } from '@/lib/i18n';
import { Button, Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui';
import { useUserDetailQuery } from '../../hooks/useUserDetailQuery';
import { BusinessDocumentPreview } from './BusinessDocumentPreview';

/**
 * 사업자등록증 보기 — 승인 대기뿐 아니라 승인 완료·반려 회원도 서류를 다시 볼 수 있게(종전엔 승인 모달에서만 보였다).
 * 목록 응답에 서류 URL 이 없으면 회원 상세를 조회해 보강한다(승인 모달과 같은 방식).
 */
export interface BusinessDocumentModalProps {
  open: boolean;
  userId: string | undefined;
  memberName: string;
  documentUrl: string | null | undefined;
  onClose: () => void;
}

export const BusinessDocumentModal = ({ open, userId, memberName, documentUrl, onClose }: BusinessDocumentModalProps) => {
  const { t } = useTranslation('common');
  const needsDetail = open && !documentUrl && Boolean(userId);
  const detail = useUserDetailQuery(needsDetail ? (userId ?? '') : '');
  const resolved = documentUrl ?? detail.data?.businessDocumentUrl ?? null;

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="business-document-modal">
        <DialogHeader>
          <DialogTitle>{t('businessMembers.document.label', '사업자등록증')}</DialogTitle>
          <DialogDescription>{memberName}</DialogDescription>
        </DialogHeader>
        <BusinessDocumentPreview documentUrl={resolved} loading={needsDetail && detail.isPending} />
        <DialogFooter>
          {userId ? (
            <Button asChild variant="outline" size="sm">
              <Link to={`/users/members/${userId}`}>{t('businessMembers.actions.detail', '회원 상세')}</Link>
            </Button>
          ) : null}
          <Button size="sm" variant="ghost" onClick={onClose}>
            {t('businessMembers.document.close', '닫기')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
